import { makeStyles } from '@material-ui/core';

export default makeStyles(
  () => ({
    layout: {
      paddingRight: '100px',
    },
  }),
  { name: 'DataValidationReport' },
);
